export default {
  classSections: [],
  sectionList: [],
  usersSectionList: [],
}
